const translations = {
    customerNotFound: 'Customer not found',
    failedToFetchCustomers: 'Failed to fetch customers',
    placeholder: 'Search for a customer',
    requiredError: 'This field is required'
};

export default translations;
